"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const AssessmentGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "ASSESSMENT-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.002-.002a2 2 0 0 1 2 2v20.004a2 2 0 0 1-2 2H1.998a2 2 0 0 1-2-2V1.998a2 2 0 0 1 2-2Zm0 1H1.998a1 1 0 0 0-1 1v20.004a1 1 0 0 0 1 1h20.004a1 1 0 0 0 1-1V1.998a1 1 0 0 0-1-1m-3.1 15.87a.5.5 0 0 1 .09.992l-.09.008H14.3a.5.5 0 0 1-.09-.992l.09-.008h4.601m0-9.202a.5.5 0 0 1 .09.992l-.09.008H14.3a.5.5 0 0 1-.09-.992l.09-.008h4.601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 13.134a.5.5 0 0 1 .147.623l-.047.077-4.6 6.134a.5.5 0 0 1-.678.117l-.076-.063-3.068-3.068a.5.5 0 0 1 .638-.764l.07.057 2.659 2.66 4.255-5.673a.5.5 0 0 1 .7-.1m0-9.202a.5.5 0 0 1 .147.623l-.047.077-4.6 6.134a.5.5 0 0 1-.678.117l-.076-.063-3.068-3.067a.5.5 0 0 1 .638-.765l.07.058 2.659 2.659L11.6 4.032a.5.5 0 0 1 .7-.1Z"
  })));
};
AssessmentGraphicIcon.displayName = "AssessmentGraphicIcon";
AssessmentGraphicIcon.iconName = "Assessment";
export default AssessmentGraphicIcon;